
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import { formatUpyunUrl } from "@/utils";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { generateMetaInfo, getServiceJsonLd, getFaqJsonLd, injectJsonLd } from "@/utils/seo";
// import {openJesongChat} from "easy"

@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb
  }
})
export default class Emba extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "实战EMBA总裁班 | 光华共创会×香港光华管理学院 - 光华赋能",
      description:
        "光华共创会与香港光华管理学院联合发起实战EMBA总裁班，旨在培养专业的企业老板，做中国最落地、最接地气的实战EMBA。面向企业负责人、联合创始人，系统学习经营管理实战课程。",
      keywords:
        "实战EMBA,EMBA总裁班,光华共创会,香港光华管理学院,企业老板培训,创始人培训,经营管理,光华赋能",
      path: "/emba",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "共创会" },
        { name: "实战EMBA" }
      ],
      jsonLd: getServiceJsonLd({
        name: "实战EMBA总裁班",
        description:
          "光华共创会与香港光华管理学院联合发起的实战EMBA总裁班，面向企业负责人与联合创始人，提供落地的经营管理实战课程。",
        category: "EMBA总裁培训"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/ae226bdec7b070be088210f70918a109.png";
  pic2 = "/img/8522c5d71b5ffc1bb80ce0fad657bb5f.png";
  pic3 = "/img/6529b831155d0b7dd37ffed0c4271aae.png";
  companyArr: any = [];
  List = [
    { title: "共创会", url: "" },
    { title: "实战EMBA", url: "" }
  ];
  created() {
    this.initData();
  }
  initData() {
    let companyArr0 = [];
    let companyArr1 = [];
    //  emba-activity2
    for (let index = 1; index < 8; index++) {
      companyArr0.push("/gh_website/emba-activity" + index + ".png");
    }
    for (let index = 8; index < 17; index++) {
      companyArr1.push("/gh_website/emba-activity" + index + ".png");
    }
    this.companyArr.push(companyArr0);
    this.companyArr.push(companyArr1);
    console.log("companyArr", this.companyArr);
  }
  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "共创会，大思维书院，实战EMBA，EMBA，常青藤"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业老板，专业的老板,实战EMBA,总裁班,学东西，交朋友，整资源，提升业务，企业负责人,联合创始人,企业接班人,大思维书院说明：标杆企业家,终身说明，前沿趋势，提升思维，思维层次，终身学习，大思维，科学经营底座，高质量发展常青藤说明：新生代企业家，传承接力，破局求变，转型升级，户外拓展，企业家私董会，共创会EMBA校友日，校友日，共创会年度高峰论坛，高峰论坛，论坛，精品研学，同学小聚"
    );
    document.head.appendChild(metaTag2);
    // 注入 FAQPage JSON-LD
    injectJsonLd(
      "jsonld-faq",
      getFaqJsonLd([
        {
          question: "实战EMBA是什么？",
          answer: "实战EMBA是光华共创会与香港光华管理学院联合推出的实战型工商管理教育项目，面向中小企业创始人与董事长，以「培养专业的老板」为使命，提供科学经营1+1+1课程体系、实战派导师、十步学习流程和九大核心权益。"
        },
        {
          question: "实战EMBA适合什么人？",
          answer: "实战EMBA主要面向企业负责人、联合创始人、企业接班人等企业决策者，要求有一定的企业经营管理经验，希望系统提升科学经营能力。"
        },
        {
          question: "实战EMBA的学期是多久？",
          answer: "实战EMBA学期为18个月，入学即享共创会会员权益，包括大思维书院、常青藤新生代联盟等社群资源。"
        },
        {
          question: "实战EMBA和传统EMBA有什么区别？",
          answer: "实战EMBA更注重实战落地，以训战结合的方式帮助学员即学即用，回到企业即可落地应用，而非传统的纯理论教学。"
        }
      ])
    );
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
